// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+2p1J","title":"styles_title__EyFV4","content":"styles_content__G4hIs","image":"styles_image__Rp3Xg"};